import { GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { ThemeToggle } from "@/components/common/ThemeToggle";

const HERO = "https://images.unsplash.com/photo-1522881193457-37ae97c905bf?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src={HERO} alt="Professor ensinando aluno" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
        <div className="absolute bottom-0 p-12 text-white">
          <p className="font-heading text-3xl font-bold leading-tight">Alunos, aulas e mensalidades<br />em um só lugar.</p>
          <p className="mt-3 max-w-md text-sm text-white/80">O ProfessorHub organiza a rotina de quem dá aulas particulares — do agendamento ao pagamento.</p>
        </div>
      </div>
      <div className="flex flex-col px-6 py-8 sm:px-12">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="auth-brand-link">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground"><GraduationCap className="h-5 w-5" /></div>
            <span className="font-heading text-lg font-bold">ProfessorHub</span>
          </Link>
          <ThemeToggle />
        </div>
        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-10">
          <h1 className="font-heading text-3xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
